export const ps: Record<string, string> = {
  "app.title": "اسناد",
  "app.subtitle": "قراردادونه په فقرو",
  "settings.language": "ژبه",
  "settings.theme": "بڼه",

  "common.loading": "بارېږي…",
  "common.close": "بندول",
  "common.back": "شاته",
  "common.error": "تېروتنه",
  "common.retry": "بیا هڅه",

  "access.title": "لاسرسی محدود دی",
  "access.body": "دا اپلیکیشن د ادارې له بلنې سره د تلیګرام بوټ له لارې پرانیزئ.",

  "docs.empty": "اوس مهال هیڅ سند نشته.",
  "docs.count": "{n} فقرې",
  "docs.pages": "مخونه",

  "doc.search": "د فقرو لټون…",
  "doc.expand_all": "ټول پرانیستل",
  "doc.collapse_all": "ټول بندول",
  "doc.download_title": "ټول سند ښکته کول",
  "doc.no_results": "هیڅ ونه موندل شو",
  "doc.results": "وموندل شول: {n}",

  "clause.open": "پرانیستل",
  "clause.download": "فقره ښکته کول",
  "clause.speak": "اوریدل",
  "clause.stop": "ودرول",
  "fmt.word": "Word",
  "fmt.pdf": "PDF",

  "download.fail": "فایل ښکته نشو",
  "download.preparing": "فایل چمتو کیږي…",

  "share.button": "شریکول",
  "share.download": "ښکته کول",
  "share.format": "فارمټ",
  "share.fail": "شریکول ونشو",
  "share.downloaded": "فایل ښکته شو",

  "tabs.documents": "اسناد",
  "tabs.letters": "لیکونه",
  "tabs.users": "کاروونکي",

  "letters.title": "لیکونه",
  "letters.subtitle": "رسمي لیکونه او راپورونه",
  "letters.empty": "تر اوسه لیک نشته.",
  "letters.doc_date": "لیک",
  "letters.added": "اضافه شو",

  "users.title": "کاروونکي او لاسرسی",
  "users.invite_heading": "کاروونکی بلل",
  "users.name_placeholder": "نوم تخلص",
  "users.make_admin": "د مدیر واک",
  "users.create": "د بلنې لینک جوړول",
  "users.creating": "جوړیږي…",
  "users.link_ready": "یو ځلي لینک (۱۴ ورځې اعتبار لري):",
  "users.copy": "کاپي",
  "users.copied": "کاپي شو ✓",
  "users.share": "شریکول",
  "users.share_text": "د «اسناد» اپلیکیشن ته بلنه",
  "users.list_heading": "کاروونکي",
  "users.role.admin": "مدیر",
  "users.role.reader": "لوستونکی",
  "users.active": "فعال",
  "users.inactive": "غیرفعال",
  "users.deactivate": "غیرفعالول",
  "users.activate": "فعالول",
  "users.empty": "اوس مهال کوم کاروونکی نشته.",
  "users.invite_fail": "بلنه جوړه نشوه",
  "users.you": "تاسو",

  "tabs.files": "فایلونه",
  "files.title": "فایلونه او فولډرونه",
  "files.new_folder": "نوی فولډر",
  "files.folder_name": "د فولډر نوم",
  "files.create": "جوړول",
  "files.empty_folders": "اوس مهال کوم فولډر نشته.",
  "files.empty_files": "دا فولډر تش دی.",
  "files.upload": "فایل پورته کول",
  "files.uploading": "پورته کیږي…",
  "files.download": "ښکته کول",
  "files.view": "کتل",
  "files.delete": "ړنګول",
  "files.confirm_del_folder": "فولډر د ټولو فایلونو سره ړنګ شي؟",
  "files.confirm_del_file": "دا فایل ړنګ شي؟",
  "files.count": "{n} فایلونه",
};
